import { useEffect } from "react";
import useCurrentTrip from "./useCurrentTrip";
import { Division } from "@/fetch/gworld";

const WORKING_HOLIDAY_ARRIVAL_ONLY_CODES = ["WH-AA", "WH-UU", "WH-CC"];

const useTripType = () => {
  const { currentTrip } = useCurrentTrip();

  const isSuperliteTrip = currentTrip?.division === Division.Superlite;
  const isWHArrivalOnly = Boolean(
    WORKING_HOLIDAY_ARRIVAL_ONLY_CODES.find(
      (each) => each === currentTrip?.trip_code
    )
  );

  return {
    isSuperliteTrip,
    isWHArrivalOnly,
  };
};

export default useTripType;
